<h1 mat-dialog-title>Otros turnos</h1>
<div class="table-scroll">
  <mat-spinner *ngIf="loading"></mat-spinner>
  <table *ngIf="!loading" class="table-content">
    <tr>
      <th class="cell-date">Fecha</th>
      <th class="cell-date">Práctica</th>
      <th class="cell-date">Equipo</th>
      <th class="cell-date">Médico</th>
      <th class="cell-date">Estado</th>
    </tr>

    <tr *ngFor="let admissionSearchItem of admissionSearchItems">
      <td class="cell-date">{{admissionSearchItem.DateTime}}</td>
      <td class="cell-date">{{admissionSearchItem.PracticeRegionName}}</td>
      <td class="cell-date">{{admissionSearchItem.EquipmentName}}</td>
      <td class="cell-date">{{admissionSearchItem.PhysicianLastNameFirstName}}</td>
      <td class="cell-date">{{admissionSearchItem.StateName}}</td>
    </tr>
  </table>
</div>
<div class="clearfix">
  <div class="pull-right">
    <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Salir</button>
  </div>
</div>
